import React, { useEffect } from "react";
import "../pages/Shipping/Components/UpsellPopUp/UpsellPopUp.css"

const UpsellUpgradeBanner: React.FC<{ onUpgradeClick: () => void }> = ({ onUpgradeClick }) => {

  const handleUpgradeClick = () => {
    onUpgradeClick();
    window.eventsTracking.track({ e: "Banner clicked" });
  };

  useEffect(() => {
    window.eventsTracking.track({ e: "Banner appears" });
  }, [])

  return (
    <div className="upgrade-box">
      <div className="upgrade-box-content">
        <div>
          <div className="upgrade-title">Upgrade auf Premium-Service</div>
          <div className="upgrade-subtitle">Medikamente liefern lassen <br />+ kostenloses Rezept</div>
        </div>
        <button className="upgrade-btn" onClick={handleUpgradeClick}>Premium ansehen</button>
      </div>
    </div>    
  );
};

export default UpsellUpgradeBanner;